import React, { useState, useMemo } from 'react';
import { Widget, Table, ColumnProps, Form, Row, FormInput, Col, Button, FormResetButton } from '@digital/ui';
import { Icon } from 'antd';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getPlanilhaOrcadoEconomicoAnoMesByProjetoId } from '@app/api/planilhaOrcadoEconomicoAnoMes';
import { compareNumber, compareDates } from '@app/helpers/comparators';
import { Projeto } from '@app/api/projeto';

interface PlanilhaOrcadoEconomicoAnoMesTabelaProps {
  atualizarTelaProp: boolean;
  projeto: Projeto;
}

const PlanilhaOrcadoEconomicoAnoMesTabela = (props: PlanilhaOrcadoEconomicoAnoMesTabelaProps) => {
  const { atualizarTelaProp, projeto } = props;
  const [colunas, setColunas] = useState<ColumnProps<any>[]>();
  const [colunasTabelaResult, setColunasTabela] = useState<ColumnProps<any>[]>();
  const [resultPlanilhaOrcadoEconomico, setResultPlanilhaOrcadoEconomico] = useState();
  const [mostarBotaoExportar, setMostarBotaoExportar] = useState<false>();

  const getAllOrdemInvestimento = useMemo(async () => {
    if (projeto) {
      const result = await getPlanilhaOrcadoEconomicoAnoMesByProjetoId(projeto.id);
      if (result) {
        if (result.nomeColunasDinamicas) {
          const colunaNome = result.nomeColunasDinamicas as string[];
          setColunasTabela(result.columnProps);
          setResultPlanilhaOrcadoEconomico(result.tabelaPlanilhaOrcadoEconomico);
          if (colunaNome) {
            if (colunaNome.length > 0) {
              setMostarBotaoExportar(true);
            }
          }
        }
      }
    }
  }, [projeto, atualizarTelaProp]);

  const colunasTabela = useMemo(() => {
    const actions = [];
    actions.push(
      {
        title: 'OI',
        dataIndex: 'oi',
        width: '3%',
        sorter: (a, b) => compareNumber(a.oi, b.oi),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="oi"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.oi !== undefined &&
          record.oi
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '3%',
        sorter: (a, b) => compareNumber(a.numero, b.numero),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Número"
                name="numero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.numero !== undefined &&
          record.numero
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '3%',
        sorter: (a, b) => compareNumber(a.numero, b.numero),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Revisão"
                name="revisao"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.revisao !== undefined &&
          record.revisao
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: 'Data de Aprovação',
        dataIndex: 'dataAprovacao',
        width: '5%',
        sorter: (a, b) => compareDates(a.dataAprovacao, b.dataAprovacao),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Data de Aprovação"
                name="dataAprovacao"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.dataAprovacao !== undefined &&
          record.dataAprovacao
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
    );

    if (colunasTabelaResult) {
      colunasTabelaResult.map(coluna => {
        actions.push({
          title: coluna.title,
          dataIndex: coluna.dataIndex,
          key: coluna.dataIndex,
          width: coluna.width,
        });
      });
    }
    return actions;
  }, [colunasTabelaResult, atualizarTelaProp]);

  return (
    <>
      <Widget title="Orçado Econômico">
        <PerfectScrollbar>
          <Table
            className="multiple-level-table tabelas-orcado"
            columns={colunasTabela}
            dataSource={resultPlanilhaOrcadoEconomico}
            pagination={false}
            rowKey="oi"
          />
        </PerfectScrollbar>
      </Widget>
    </>
  );
};

export default PlanilhaOrcadoEconomicoAnoMesTabela;
